export default function (projectBillingType) {
  var addWorkType = function (name="", rate=0.0) {
    var workTypes = $('.work-types');
    var prototype = $('#prototype').html();

    var index = workTypes.data('index') ? workTypes.data('index') : workTypes.find('.work-type').length;
    var newForm = prototype.replace(/__name__/g, index);
  
    newForm = $.parseHTML(newForm);
    var inputs = newForm[1].querySelectorAll("input")
    inputs[0].value = name;
    inputs[2].value = rate.toFixed(1);

    workTypes.append(newForm);
    workTypes.data('index', index + 1);

    toggleEmptyMessage();
  };
  
  var workTypeCount = function() {
    return $('.work-types').find('.work-type').length;
  }

  var toggleEmptyMessage = function () {
    var message = $('#empty-message');

    if (workTypeCount() > 0) {
      message.hide();
      return
    }
    message.show();
  }

  var defaultWorkTypes = function() {
    if (workTypeCount() <= 0) {
      switch(projectBillingType) {
      case 2:
        addWorkType("On Site", 0.0);
        addWorkType("Unbilled", 0.0);
        addWorkType("Remote", 0.0);
        break;
      case 3:
        addWorkType("Internal Development", 0.0);
        break;
      default:
        break;
      }
    }
  }

  $('.add-work-type').click(function(e) {
    e.preventDefault();
    addWorkType();
  });

  $(document).on('click', '.work-type .remove', function(e) {
    e.preventDefault();
    $(this).parents('.work-type').remove();
    toggleEmptyMessage();
  });

  defaultWorkTypes();
  toggleEmptyMessage();
}


// WEBPACK FOOTER //
// ./assets/js/edit-project-work-types.js